import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Layout.css';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="brand">
            <img src="/kaammytra-logo.png" alt="KaamMytra" className="logo" />
            <h2>kaammytra</h2>
          </div>
          {sidebarOpen && (
            <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
              ◀
            </button>
          )}
        </div>
        
        <nav className="sidebar-nav">
          <a href="/dashboard" className="nav-item">
            <span className="icon">📊</span>
            {sidebarOpen && <span>Dashboard</span>}
          </a>
          <Link to="/register-retailer" className="nav-item">
            <span className="icon">➕</span>
            {sidebarOpen && <span>Register Retailer</span>}
          </Link>
          <a href="/submit-loan" className="nav-item">
            <span className="icon">📝</span>
            {sidebarOpen && <span>Submit Loan</span>}
          </a>
          <a href="/record-collection" className="nav-item">
            <span className="icon">💰</span>
            {sidebarOpen && <span>Record Collection</span>}
          </a>
          <Link to="/collection-history" className="nav-item">
            <span className="icon">📋</span>
            {sidebarOpen && <span>Collection History</span>}
          </Link>
          <Link to="/retailers" className="nav-item">
            <span className="icon">🏪</span>
            {sidebarOpen && <span>All Retailers</span>}
          </Link>
          <Link to="/my-loans" className="nav-item">
            <span className="icon">📄</span>
            {sidebarOpen && <span>My Loans</span>}
          </Link>
          <Link to="/reports" className="nav-item">
            <span className="icon">📈</span>
            {sidebarOpen && <span>Reports</span>}
          </Link>
        </nav>
      </aside>
      <main className="main-content">
        <header className="header">
          <button className="menu-button" onClick={() => setSidebarOpen(!sidebarOpen)}>
            ☰
          </button>
          <div className="header-right">
            <div className="user-info">
              <span className="user-name">{user?.name || 'Agent'}</span>
              <button className="logout-button" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </header>
        <div className="content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
